module.exports = __webpack_public_path__ + "static/media/FoodTruckLogo.a1bfbf6a.png";